import axios from "axios";

export const allTech = async (authtoken) => {
  return await axios.get(`${process.env.REACT_APP_API}/auth/getalluser`, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};

export const techDetails = async (authtoken, id) => {
  return await axios.get(
    `${process.env.REACT_APP_API}/auth/userdetails/${id}`,
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};

export const addTech = async (authtoken, ...tech) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/auth/register`,
    ...tech,
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};

export const taskAssign = async (authtoken, id) => {
  return await axios.get(
    `${process.env.REACT_APP_API}/workOrders/userId/${id}`,
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};

export const techPagination = async (authtoken, page) => {
  return await axios.get(
    `${process.env.REACT_APP_API}/user/techall?page=${page}`,
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};

export const updateTechApi = async (authtoken, id, ...updatetech) => {
  return await axios.put(
    `${process.env.REACT_APP_API}/user/tech/${id}`,
    ...updatetech,
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};

export const deleteTechApi = async (authtoken, id) => {
  return await axios.delete(`${process.env.REACT_APP_API}/user/tech/${id}`, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};

export const searchTech = async (authtoken, name) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/user/searchtech`,
    { name },
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};
